/**
 *
 * @param {object[]} data
 * @param {column[]} columns
 * @param {{showNo:boolean,includeTotals:boolean,totals:object, renderField:object, wf:object}} options
 */
import { getWFStatus } from 'src/helper';
function generateExportableData(
  data = [],
  columns = [],
  options = {
    showNo: false,
    includeTotals: false,
    totals: {},
    renderStatus: false,
    wf: {}
  }
) {
  const res = [];
  const { wf } = options;

  // generate header
  const header = [];

  if (options.showNo) {
    header.push('No.');
  }

  for (const col of columns) {
    if (col.headerName) {
      header.push(col.headerName);
    }
  }
  res.push(header);

  // add the data
  for (const [index, dataItem] of data.entries()) {
    const row = [];
    if (options.showNo) {
      row.push(index + 1);
    }
    for (const col of columns) {
      if (col.headerName) {
        if (col?.render?.ixJCd && options.renderStatus) {
          const jsonWF = wf?.[col.render.ixJCd]?.wf ?? {};
          row.push(getWFStatus(jsonWF, dataItem[col.field]));
        } else {
          row.push(dataItem[col.field]); // Normal push value into row
        }
      }
    }
    res.push(row);
  }

  // adding totals
  if (options.includeTotals) {
    const totalRow = [];

    for (const col of columns) {
      totalRow.push(
        options.totals.hasOwnProperty(col.field)
          ? options.totals[col.field]
          : ''
      );
    }

    res.push(totalRow);
  }

  return res;
}

export default generateExportableData;
